// @flow
import styled from 'styled-components';

export const StyledRouterLink = styled.span`
    a {
        color: ${({ theme, alternate }) => (alternate ? theme.secondaryLinkColor : theme.mainBrandColor)};
        text-decoration: none;
    }
`;

export const StyledExternalLink = styled.a`
    color: ${({ theme, alternate }) => (alternate ? theme.secondaryLinkColor : theme.mainBrandColor)};
    text-decoration: none;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/link/styles.js